import React from 'react'
import Logo from "@/images/logotype.png"
import { useSelector } from 'react-redux'
import { selectSelectedTool } from '@/store/slices/ToolsSlice'
import { useTranslation } from 'react-i18next'

const LogoSection = ({ uploading, onLogoClick }) => {
  const { t } = useTranslation()
  const selectedTool = useSelector(selectSelectedTool)
  const path = window.location.pathname
  const isHeader = (path === '/' || path === '/settings')

  return (
    <div className={`flex items-center gap-3 ${uploading ? "cursor-not-allowed" : "cursor-pointer"}`}>
      <img 
        className='w-[104px] h-6 object-contain' 
        src={Logo} 
        alt="logo not found" 
        onClick={() => onLogoClick('home')} 
      />
      <p 
        className='text-black font-SuisseIntlLight font-normal w-[153px] h-6 md:text-base text-sm mt-2 md:mt-[2px] md:inline' 
        onClick={() => onLogoClick('tool')}
      >
        {isHeader ? t('header.medicalAiSuite') : selectedTool}
      </p>
    </div>
  )
}

export default LogoSection
